<div class="left-menu" [class.mobile-open]="mobileMenuOpen$ | async">
  <!-- <div class="menu-header">
    <div class="team-info">
      <div class="team-avatar">
        <mat-icon>sports_basketball</mat-icon>
      </div>
      <div class="team-details">
        <h3 class="team-name">Gran Torino</h3>
        <p class="team-subtitle">Basketball Draft</p>
      </div>
    </div>
  </div> -->

  <nav class="menu-nav">
    <div class="menu-section">
      <!-- <div class="menu-section-label">Navigation</div> -->
      <div class="menu-items">
        @for (item of menuItems; track item.route) {
          @if (rbac.hasPermission(item.permission)) {
            <a [routerLink]="item.route" class="menu-item" (click)="onMenuItemClick(item)" routerLinkActive="active">
              <div class="menu-item-container">
                <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
                <span class="menu-label">{{ item.labelKey | transloco }}</span>
              </div>
            </a>
          }
        }
      </div>
    </div>
  </nav>
</div>